<div class="subpage-container">
    <div class="container g-0 m-0">
        <div class="row g-0 m-0 d-flex align-items-center mt-3 pt-4 pb-3">
            <div class="col-md-12 pb-2 ps-5 d-flex align-items-center gap-3">
                <img class="page-icon" alt="Download" src="assets/core/table/download-button.svg" />
                <div>
                    <h2 class="m-0 title">
                        {{"METER_SETUP_DESKTOP_APP" | translate}}
                    </h2>
                    <h6 class="m-0 subtitle">
                        {{"METER_SETUP_DESKTOP_APP_SUBTITLE" | translate}}
                    </h6>
                </div>
            </div>
        </div>

        <div class="row g-0 m-0 px-5">
            <div class="info-card d-flex flex-wrap">
                <div class="info-about d-flex gap-3">
                    <img class="info-icon" alt="" src="assets/desktop-app/desktop-app-info.svg" />
                    <div>
                        <h5 class="card-title">{{"METER_SETUP_DESKTOP_APP_ABOUT_TITLE" | translate}}</h5>
                        <p class="card-text m-0">{{"METER_SETUP_DESKTOP_APP_ABOUT_TEXT" | translate}}</p>
                    </div>
                </div>
                <div class="info-features">
                    <h5 class="card-title">{{"METER_SETUP_DESKTOP_APP_KEY_FEATURES" | translate}}</h5>
                    <div class="feature d-flex align-items-center gap-2" *ngFor="let feature of features">
                        <img class="feature-check" alt="" src="assets/core/table-button/radiobuttonchecked.svg" />
                        <span>{{ feature | translate }}</span>
                    </div>
                </div>
            </div>
        </div>

        <div class="row g-0 m-0 px-5 pt-4">
            <div class="col-md-12 p-0">
                <h5 class="section-title m-0">{{"METER_SETUP_DESKTOP_APP_AVAILABLE_VERSIONS" | translate}}</h5>
                <h6 class="subtitle">{{"METER_SETUP_DESKTOP_APP_AVAILABLE_VERSIONS_SUBTITLE" | translate}}</h6>
            </div>
        </div>

        <div class="row g-0 m-0 px-5">
            <div class="version-card d-flex align-items-center gap-3" *ngFor="let file of files; let first = first"
                [class.version-latest]="first">
                <img class="version-icon" alt="" src="assets/desktop-app/desktop-app-version.svg" />
                <div class="version-name d-flex align-items-center gap-2">
                    <span class="file-name">{{ file.fileName }}</span>
                    <span class="latest-badge" *ngIf="first">{{"METER_SETUP_DESKTOP_APP_LATEST" | translate}}</span>
                </div>
                <div class="version-meta">
                    <span class="meta-label">{{"METER_SETUP_DESKTOP_APP_SIZE" | translate}}</span>
                    <span class="meta-value">{{ formatSize(file.size) }}</span>
                </div>
                <div class="version-meta">
                    <span class="meta-label">{{"METER_SETUP_DESKTOP_APP_RELEASED" | translate}}</span>
                    <span class="meta-value">{{ file.lastModified | date: 'dd MMM yyyy, h:mm a' }}</span>
                </div>
                <button class="download-button d-flex align-items-center gap-2"
                    (click)="first ? downloadLatest() : download(file)">
                    <img alt="" src="assets/core/table/download.svg" />
                    {{"DOWNLOAD" | translate}}
                </button>
            </div>

            <div class="version-card empty" *ngIf="!loading && files.length === 0">
                <span>{{"NO_DATA" | translate}}</span>
            </div>
        </div>
    </div>
</div>
